import { render, staticRenderFns } from "./FormKuukausiraportti.vue?vue&type=template&id=38cacb7a&scoped=true&"
import script from "./FormKuukausiraportti.vue?vue&type=script&lang=js&"
export * from "./FormKuukausiraportti.vue?vue&type=script&lang=js&"
import style0 from "./FormKuukausiraportti.vue?vue&type=style&index=0&id=38cacb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cacb7a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VCombobox,VDatePicker,VForm,VMenu,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cacb7a')) {
      api.createRecord('38cacb7a', component.options)
    } else {
      api.reload('38cacb7a', component.options)
    }
    module.hot.accept("./FormKuukausiraportti.vue?vue&type=template&id=38cacb7a&scoped=true&", function () {
      api.rerender('38cacb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormKuukausiraportti.vue"
export default component.exports